
  <section class="contact-page-area section-gap" >
    <div style="height:50px">

    </div>
  <div class="container">
    <div class="right">
      <br><br>
      <div class="address">
        <div   style="text-align: right; margin-right: 35px; color: rgba(255, 255, 255, 0.595)" *ngIf="document.documentElement.dir == 'rtl'">
          <div  >
              <h6>
                آدرس: میدان آزادی، چهارراه فرایبورگ، خیابان مصلی، خیابان معلم(شاطرگلی)، پلاک ۱۲۳
              </h6>
          </div>
          <div >
              <h6>تلفن: 03136639050 </h6>
          </div>
          <div>
              <h6> ایمیل: info@didartaxi.ir </h6>
          </div>
        </div>
        <div style="text-align: left;  margin-left: -70px; color: rgba(255, 255, 255, 0.595)" *ngIf="document.documentElement.dir == 'ltr'">
          <div >
              <h6>
               Address: Rezai alley (21), Mosala St, Esfahan.
              </h6>
          </div>
          <div >
              <h6>Phone: 03136639050 </h6>
          </div>
          <div>
              <h6> Email: info@didartaxi.ir </h6>
          </div>
        </div>
      </div>



      <div  class="center" id="data">
      <div  style="background-color: #f9d700; margin: 40px; width: 400px; height: 400px;">
        <div style="margin: 30px">
          <div style="text-align: center">
            <br>
            <label
              ><h4>{{ "register" | translate }}</h4></label
            >

          </div>
          <form
            [formGroup]="signupForm"
            (ngSubmit)="onSubmit()"
            [style.text-align]="
              document.documentElement.dir == 'rtl' ? 'right' : 'left'
            "
          >
            <div class="form-group">
              <!-- <label for="fullname">{{ "fullname" | translate }}:</label> -->
              <input
                type="text"
                id="fullname"
                formControlName="fullname"
                class="form-control"
                placeholder= "{{ 'fullname' | translate  }}"
              />
              <span
                *ngIf="
                  !signupForm.get('fullname').valid &&
                  signupForm.get('fullname').touched
                "
                class="help-block"
                >Please enter a valid name!</span
              >
            </div>
            <div class="form-group">
              <!-- <label for="mail">{{ "mail" | translate }}:</label> -->
              <input
                type="email"
                id="mail"
                formControlName="mail"
                class="form-control"
                placeholder= "{{ 'mail' | translate  }}"
              />
              <span
                *ngIf="
                  !signupForm.get('mail').valid && signupForm.get('mail').touched
                "
                class="help-block"
                >Please enter a valid email!</span
              >
            </div>
            <div class="form-group">
              <!-- <label for="phone">{{ "phone" | translate }}:</label> -->
              <input
                type="tel"
                id="phone"
                formControlName="phone"
                class="form-control"
                placeholder= "{{ 'phone' | translate  }}"
              />
              <span
                *ngIf="
                  !signupForm.get('phone').valid &&
                  signupForm.get('phone').touched
                "
                class="help-block"
                >Please enter a valid phone number!</span
              >
            </div>
            <div class="form-group">
              <!-- <label for="address">{{ "address" | translate }}:</label> -->
              <textarea
                type="email"
                id="address"
                formControlName="address"
                class="form-control"
                placeholder= "{{ 'address' | translate  }}"
              ></textarea>
              <span
                *ngIf="
                  !signupForm.get('address').valid &&
                  signupForm.get('address').touched
                "
                class="help-block"
                >Please enter a valid Address!</span
              >
            </div>

            <!-- <span
              *ngIf="!signupForm.valid && signupForm.touched"
              class="help-block"
              >Please enter a valid data!</span
            > -->

            <div>
              <button class="btn btn-primary" type="submit">
                {{ "submit" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>

      </div>
    </div>

    <div class="left">
      <div class="map-wrap center">

        <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1333.4836711252312!2d51.67785797233725!3d32.62833900207443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3b642a3ce98737a6!2zMzLCsDM3JzQxLjIiTiA1McKwNDAnNDIuOCJF!5e0!3m2!1sen!2slv!4v1644265615553!5m2!1sen!2slv"
        width="550px"
        height="550px"

        frameborder="0"
        style="border: 0"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0"
      ></iframe>
      </div>
    </div>


  </div>
<div class="h-100">


</div>
  </section>



